const styles = (theme) => ({
  boxPrioridade: {
    minWidth: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  textPrioridade: {
    fontSize: "9px",
    fontWeight: 900,
    color: theme.palette.white.main,
  },
});

export default styles;
